<template>
  <VincCalculatingList />
</template>

<script>
import VincCalculatingList from "@/components/Calculatings/VincCalculating/List.vue";
export default {
  components: { VincCalculatingList },
};
</script>

<style></style>
